import React, { useEffect, useState } from 'react';
import PropType from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row } from 'antd';
import CustomerIdentity from './CustomerIdentify';
import SimilarKYCCustomer from './similarKYCCustomer';
import {
  getAMLSCommonAlertPartyIdentity,
  clearAMLSCommonUnifiedAlerts,
  getCommonKYCcustomers,
  getCommonKYCcustomersDownload
} from '../../../../redux/actions/common';
import AlertHistoryMeta from '../../../common/AlertHistoryMeta';
import MainPanel from './MainPanel';
import GraphPanel from './GraphPanel';
import AssociatedAccounts from '../../../common/associatedAccounts/AssociatedAccounts';
import { LOAN_DETAILS_WIDGET_SETTINGS } from '../../../common/associatedAccounts/constants';

const CardViews = ({
  alertId,
  alertPartyIdentity,
  isPrevention,
  apiActions,
  clearUnifiedAlertsData,
  getCommonKYCcustomersData,
  commonKYCCustomers,
  getCommonKYCcustomersDownloadData,
  commonKYCCustomersDownload,
  alertDetails,
  handleGraphClick = () => null
}) => {
  const [customerId, setCustomerID] = useState();

  const getCustomerID = (ID) => {
    setCustomerID(ID);
  };

  // sender
  const sampleSenderTitle = 'Sender Details';
  let sampleSenderData = [
    { fieldLabel: 'ID:', fieldValue: '-' },
    { fieldLabel: 'Timestamp:', fieldValue: '-' },
    { fieldLabel: 'Type:', fieldValue: '-' },
    { fieldLabel: 'Category:', fieldValue: '-' }
  ];

  let sampleSenderFooterData = [{ fieldLabel: 'ID:', fieldValue: '-' }];

  // partner
  const samplePartnerTitle = 'Partner Details';
  let samplePartnerData = [
    { fieldLabel: 'Sending Partner Code:', fieldValue: '-' },
    { fieldLabel: 'Sending Partner Type:', fieldValue: '-' },
    { fieldLabel: 'Sending Partner:', fieldValue: '-' }
  ];

  let samplePartnerFooterData = [
    { fieldLabel: 'Receiving Partner Code:', fieldValue: '-' },
    { fieldLabel: 'Receiving Partner Type:', fieldValue: '-' },
    { fieldLabel: 'Receiving Partner:', fieldValue: '-' }
  ];

  // beneficiary
  const sampleBeneficiaryTitle = 'Beneficiary Details';
  let sampleBeneficiaryData = [
    { fieldLabel: 'Name:', fieldValue: '-' },
    { fieldLabel: 'Hashcode:', fieldValue: '-' },
    { fieldLabel: 'Country Risk Level:', fieldValue: '-' },
    { fieldLabel: 'Occupation:', fieldValue: '-' },
    { fieldLabel: 'Nationality:', fieldValue: '-' },
    { fieldLabel: 'Destination Country:', fieldValue: '-' }
  ];

  let sampleBeneficiaryFooterData = [
    { fieldLabel: 'Receiving Partner Risk:', fieldValue: '-' }
  ];

  if (alertPartyIdentity && alertPartyIdentity.data) {
    // loop through different items in reducers
    let senderData = {};
    let partnerData = {};
    let beneficiaryData = {};
    let sendingPartnerData = {};
    let receivingPartnerData = {};
    if (alertPartyIdentity.data) {
      const customerKeys = Object.keys(alertPartyIdentity.data) || [];
      customerKeys.forEach((customerKey) => {
        const SENDER = 'SENDER';
        const BENEFICIARY = 'Beneficiary';
        const RECEIVER = 'RECEIVER';
        const SENDING_PARTNER = 'SENDING PARTNER';
        const RECEIVING_PARTNER = 'RECEIVING PARTNER';

        if (
          String(
            alertPartyIdentity.data[customerKey]?.entityRole
          ).toUpperCase() === SENDER
        ) {
          senderData = alertPartyIdentity.data[customerKey];
        }

        if (
          String(
            alertPartyIdentity.data[customerKey]?.entityRole
          ).toUpperCase() === RECEIVER
        ) {
          beneficiaryData = alertPartyIdentity.data[customerKey];
        }

        if (
          String(
            alertPartyIdentity.data[customerKey]?.entityRole
          ).toUpperCase() === SENDING_PARTNER
        ) {
          sendingPartnerData = alertPartyIdentity.data[customerKey];
        }

        if (
          String(
            alertPartyIdentity.data[customerKey]?.entityRole
          ).toUpperCase() === RECEIVING_PARTNER
        ) {
          receivingPartnerData = alertPartyIdentity.data[customerKey];
        }

        if (alertPartyIdentity.data[customerKey]?.entityRole === BENEFICIARY) {
          beneficiaryData = alertPartyIdentity.data[customerKey];
        }
      });
    }

    if (senderData || sendingPartnerData) {
      const {
        partyKey,
        partyName,
        countryRiskLevel,
        occupation,
        citizenshipCountry,
        residenceOperationCountry
      } = senderData;

      sampleSenderData = [
        { fieldLabel: 'Name:', fieldValue: partyName || '-' },
        { fieldLabel: 'Hashcode:', fieldValue: partyKey || '-' },
        {
          fieldLabel: 'Country Risk Level:',
          fieldValue: countryRiskLevel || '-'
        },
        { fieldLabel: 'Occupation:', fieldValue: occupation || '-' },
        { fieldLabel: 'Nationality:', fieldValue: citizenshipCountry || '-' },
        {
          fieldLabel: 'Source Country:',
          fieldValue: residenceOperationCountry || '-'
        }
      ];

      sampleSenderFooterData = [
        {
          fieldLabel: 'Sending Partner Risk:',
          fieldValue: sendingPartnerData?.riskRating || '-'
        }
      ];
    }

    if (sendingPartnerData || receivingPartnerData) {
      samplePartnerData = [
        {
          fieldLabel: 'Sending Partner Code:',
          fieldValue: sendingPartnerData?.partyKey || '-'
        },
        {
          fieldLabel: 'Sending Partner Type:',
          fieldValue: sendingPartnerData?.customerType || '-'
        },
        {
          fieldLabel: 'Sending Partner:',
          fieldValue: sendingPartnerData?.partyName || '-'
        }
      ];

      samplePartnerFooterData = [
        {
          fieldLabel: 'Receiving Partner Code:',
          fieldValue: receivingPartnerData?.partyKey || '-'
        },
        {
          fieldLabel: 'Receiving Partner Type:',
          fieldValue: receivingPartnerData?.customerType || '-'
        },
        {
          fieldLabel: 'Receiving Partner:',
          fieldValue: receivingPartnerData?.partyName || '-'
        }
      ];
    }

    if (beneficiaryData || receivingPartnerData) {
      const {
        partyKey,
        partyName,
        countryRiskLevel,
        occupation,
        citizenshipCountry,
        residenceOperationCountry
      } = beneficiaryData;
      sampleBeneficiaryData = [
        { fieldLabel: 'Name:', fieldValue: partyName || '-' },
        { fieldLabel: 'Hashcode:', fieldValue: partyKey || '-' },
        { fieldLabel: 'Country Risk Level:', fieldValue: countryRiskLevel },
        { fieldLabel: 'Occupation:', fieldValue: occupation || '-' },
        { fieldLabel: 'Nationality:', fieldValue: citizenshipCountry || '-' },
        {
          fieldLabel: 'Destination Country:',
          fieldValue: residenceOperationCountry || '-'
        }
      ];

      sampleBeneficiaryFooterData = [
        {
          fieldLabel: 'Receiving Partner Risk:',
          fieldValue: receivingPartnerData?.riskRating || '-'
        }
      ];
    }
  }

  if (isPrevention) {
    return (
      <Row gutter={[20, 20]}>
        <Col>
          <MainPanel
            title={sampleSenderTitle}
            data={sampleSenderData}
            footerData={sampleSenderFooterData}
          />
        </Col>
        <Col>
          <MainPanel
            title={samplePartnerTitle}
            data={samplePartnerData}
            footerData={samplePartnerFooterData}
          />
        </Col>
        <Col>
          <MainPanel
            title={sampleBeneficiaryTitle}
            data={sampleBeneficiaryData}
            footerData={sampleBeneficiaryFooterData}
          />
        </Col>

        <Col span={23}>
          <GraphPanel
            alertDetails={alertDetails}
            handleGraphClick={handleGraphClick}
          />
        </Col>
        {/* <Col span={24}>
        <SimilarKYCCustomer
          getCommonKYCcustomersData={getCommonKYCcustomersData}
          getCommonKYCcustomersDownloadData={getCommonKYCcustomersDownloadData}
          commonKYCCustomers={commonKYCCustomers}
          commonKYCCustomersDownload={commonKYCCustomersDownload}
          customerId={customerId}
          alertId={alertId}
        />
      </Col> */}
      </Row>
    );
  } else {
    return (
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <CustomerIdentity {...{ alertPartyIdentity }} />
        </Col>
        <Col span={12}>
          <AlertHistoryMeta alertId={alertId} getCustomerID={getCustomerID} />
        </Col>
        <Col span={24}>
          <AssociatedAccounts
            customerId={customerId}
            settings={LOAN_DETAILS_WIDGET_SETTINGS}
          />
        </Col>
        <Col span={24}>
          <SimilarKYCCustomer
            getCommonKYCcustomersData={getCommonKYCcustomersData}
            getCommonKYCcustomersDownloadData={
              getCommonKYCcustomersDownloadData
            }
            commonKYCCustomers={commonKYCCustomers}
            commonKYCCustomersDownload={commonKYCCustomersDownload}
            customerId={customerId}
            alertId={alertId}
          />
        </Col>
      </Row>
    );
  }
};

const mapStateToProps = (state) => {
  const {
    alertPartyIdentity = {},
    commonKYCCustomers = {},
    commonKYCCustomersDownload = {},
    alertDetails = {}
  } = state.amlsCommon;
  return {
    alertPartyIdentity,
    commonKYCCustomers,
    commonKYCCustomersDownload,
    alertDetails
  };
};

const mapDispatchToProps = (dispatch) => ({
  apiActions: (alertId) => dispatch(getAMLSCommonAlertPartyIdentity(alertId)),
  clearUnifiedAlertsData: () => dispatch(clearAMLSCommonUnifiedAlerts()),
  getCommonKYCcustomersData: (payload) =>
    dispatch(getCommonKYCcustomers(payload)),
  getCommonKYCcustomersDownloadData: (payload) =>
    dispatch(getCommonKYCcustomersDownload(payload))
});

CardViews.propTypes = {
  alertPartyIdentity: PropType.object,
  alertId: PropType.string,
  apiActions: PropType.func,
  alertDetails: PropType.object
};

export default connect(mapStateToProps, mapDispatchToProps)(CardViews);
